import * as type from '../../types/API/packagingMasterType';
import { IAction } from '../userMetadataReducer';

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const getPackagingMasterReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_PACKAGING_MASTER:
      return {
        ...state,
        loading: true,
      };
    case type.GET_PACKAGING_MASTER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.GET_PACKAGING_MASTER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const addPackagingMasterReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.ADD_PACKAGING_MASTER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.ADD_PACKAGING_MASTER_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.ADD_PACKAGING_MASTER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        data: null
      };
    default:
      return state;
  }
};

export const editPackagingMasterReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.EDIT_PACKAGING_MASTER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.EDIT_PACKAGING_MASTER_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.EDIT_PACKAGING_MASTER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const deletePackagingMasterReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.DELETE_PACKAGING_MASTER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.DELETE_PACKAGING_MASTER_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.DELETE_PACKAGING_MASTER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};
